@if (user) {
  <div class="flex items-center gap-3 overflow-hidden">
    <div
      class="flex size-9 shrink-0 items-center justify-center rounded-full bg-blue-500 text-sm font-semibold text-white"
    >
      {{ user.abbreviation }}
    </div>
    <div>
      <a
        class=""
        [href]="`mailto:${user.email}`"
        [title]="user.email"
        [innerHTML]="user.email | highLightText: highlight"
      ></a>
    </div>
  </div>
} @else {
  <div class="flex items-center gap-3">
    <div
      class="flex size-10 items-center justify-center rounded-full bg-grey-400 text-sm font-semibold text-white"
    >
      <svg-icon src="assets/icons/Users/user-x-01.svg" />
    </div>
    <div class="font-medium text-grey-500">
      <p>{{ 'components.user.noUser' | translate }}</p>
      <a
        class=""
        [href]="`mailto:${userMail}`"
        [title]="userMail"
        [innerHTML]="userMail | highLightText: highlight"
      ></a>
    </div>
  </div>
}
